import type { FC } from 'react';
import type { EntityData } from '@domain/types/entity';
import { useRenewalsData } from '@queries/fetchRenewals';

import { ListRenewalsButton } from '../views/ListRenewalsButton';

interface RenewalsButtonControllerProps {
  submission: EntityData;
}

export const RenewalsButtonController: FC<RenewalsButtonControllerProps> = ({ submission }) => {
  const { data, isFetching } = useRenewalsData();

  return <ListRenewalsButton data={data} isLoading={isFetching && !data} submission={submission} />;
};
